import React from "react";
import BoxShadow from "../../../../../../../Common/Components/BoxShadow";
import Form from "../Form";
import CardTime from "./Card";

const Shift = ({ form, setForm, inputs }) => {
  const deleteTime = _id => {
    setForm({
      ...form,
      times: form.times.filter(ele => ele._id !== _id),
    });
  };
  return (
    <>
      <BoxShadow style={{ marginTop: "20px", padding: "10px" }}>
        <Form form={form} inputs={inputs} setForm={setForm} />
      </BoxShadow>
      <div className="row mt-3">
        {form.times.map((time, count) => {
          return (
            <CardTime
              deleteItem={deleteTime}
              key={count}
              time={time}
              options={form.option}
            />
          );
        })}
      </div>
    </>
  );
};

export default Shift;
